// extracted by mini-css-extract-plugin
module.exports = {"radio":"radio___22DmG","is-active":"is-active___fzxp0","text":"text___2rv5k"};